module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    attrs: {
      "data": _vm.jars
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": "Version"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Status"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-progress', {
          attrs: {
            "percentage": scope.row.status === 'installed' ? 100 : (scope.row.download && parseInt(scope.row.download.percentage * 100) || 0),
            "status": scope.row.status === 'installed' ? 'success' : ''
          }
        })]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Action"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button-group', [_c('el-button', {
          attrs: {
            "disabled": scope.row.status !== 'uninstall',
            "loading": scope.row.status === 'installing',
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.installJar(scope.row)
            }
          }
        }, [_vm._v("Install\n          ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "disabled": scope.row.status === 'installing',
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.deleteJar(scope.$index)
            }
          }
        }, [_vm._v("\n            Delete\n          ")])], 1)]
      }]
    ])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Add Jar"
    },
    model: {
      value: (_vm.addJarModal),
      callback: function($$v) {
        _vm.addJarModal = $$v
      },
      expression: "addJarModal"
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.$store.state.version.loading),
      expression: "$store.state.version.loading"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "Minecraft Version"
    }
  }, [_c('version-select', {
    model: {
      value: (_vm.newJarModal.version),
      callback: function($$v) {
        _vm.newJarModal.version = $$v
      },
      expression: "newJarModal.version"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.addJarModal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.addingJar
    },
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-e8684be6"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/jar/Index.vue
// module id = 175
// module chunks = 1